import axios from 'axios'
import { UAParser } from 'ua-parser-js'

const HOST = process.env.VUE_APP_ANALYTICS_HOST
const API_TOKEN = process.env.VUE_APP_ANALYTICS_API_TOKEN
const API_URL = `${HOST}`

const APP_VERSION = process.env.VUE_APP_VERSION

const EVENTS_URL = '/events'
const SESSIONS_URL = '/sessions'
const IDENTITIES_URL = '/identities'

function getDeviceType() {
  const ua = navigator.userAgent

  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return 'tablet'
  }
  if (
    /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua
    )
  ) {
    return 'mobile'
  }
  // Check for touch capability as a fallback for some devices
  if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
    return 'touch-enabled desktop/laptop'
  }
  return 'desktop'
}

function getDeviceDetails() {
  const uap = new UAParser()
  const uapRes = uap.getResult()

  let deviceType = getDeviceType()
  let deviceModel = null
  let deviceVendor = null
  if (!uapRes.device.model) {
    deviceModel = getDeviceType()
  } else {
    deviceModel = uapRes.device.model.toLowerCase()
    if (uapRes.device.vendor) {
      deviceVendor = uapRes.device.vendor.toLowerCase()
    }
  }

  let os = uapRes.os.name.toLowerCase()
  if (os === 'macos' && navigator.maxTouchPoints > 2) {
    os = 'ipad'
    deviceType = 'tablet'
  }

  let cpu = null
  if (uapRes.cpu) {
    cpu = uapRes.cpu.architecture
  }

  let res = {
    browser: {
      name: uapRes.browser.name.toLowerCase(),
      version: uapRes.browser.version,
      engine: uapRes.engine.name.toLowerCase(),
      engineVersion: uapRes.engine.version,
      language: navigator.language
    },
    device: {
      os: os,
      version: uapRes.os.version,
      model: deviceModel,
      vendor: deviceVendor,
      cpu: cpu,
      type: deviceType,
      resolution: `${window.screen.width} x ${window.screen.height}`,
      dpi: parseInt(window.devicePixelRatio)
    },
    webVersion: APP_VERSION
  }
  // Cleans up the object removing undefined
  res = JSON.parse(JSON.stringify(res, (k, v) => v ?? undefined))
  return res
}

function handleResponse(response, resolve, reject) {
  if (response.unauthorized) {
    reject(response.error)
  } else if (response.status === 'error') {
    reject(response.error)
  } else {
    resolve(response)
  }
}

export default {
  API_URL: `${HOST}`,
  API_TOKEN: API_TOKEN,
  newRequest(method, url, payload) {
    const fullUrl = API_URL + url
    const headers = {
      'Content-Type': 'application/json',
      'X-API-Token': API_TOKEN
    }

    return new Promise(function(resolve, reject) {
      axios({
        method: method,
        url: fullUrl,
        data: payload,
        headers: headers
      })
        .then(resp => {
          console.log(resp.data)
          console.log(resp.status)
          console.log(resp.statusText)
          console.log(resp.headers)
          console.log(resp.config)
          handleResponse(resp.data, resolve, reject)
        })
        .catch(error => {
          console.log(error)
          const errorResponse = {
            code: 0,
            title: 'Unkown API error',
            message: 'Unkown API error'
          }
          if (error.response) {
            if (
              error.response.status === 404 &&
              error.response.data?.error?.details?.includes('The Identity')
            ) {
              window.localStorage.removeItem('fvuid')
            }
            // if (error.response.status === 401) {
            //   // Sign out unauthorized tokens
            //   store.dispatch('auth/signout')
            //   // router.push('/login')
            // } else if (error.response.data && error.response.data.status === 'error') {
            //   errorResponse = error.response.data.error
            // }
          } else {
            errorResponse.title = error.message
            errorResponse.message = error.message
          }
          reject(errorResponse)
        })
    })
  },
  startSession: async function() {
    const deviceDetails = getDeviceDetails()
    const payload = {
      uid: window.localStorage.getItem('fvuid'),
      data: deviceDetails
    }
    try {
      const res = await this.newRequest('post', SESSIONS_URL, payload)
      if (res.data.sid) {
        window.localStorage.setItem('fvsid', res.data.sid)
      }
      if (res.data.uid) {
        window.localStorage.setItem('fvuid', res.data.uid)
      }
      return res
    } catch (err) {
      console.log(err)
    }
  },
  endSession: async function() {
    const sid = window.localStorage.getItem('fvsid')
    await this.newRequest('post', `${SESSIONS_URL}/${sid}`)
    // Clear the session id
    window.localStorage.removeItem('fvsid')
  },
  setIdentity: async function(id) {
    const payload = {
      extid: id
    }
    const fvuid = window.localStorage.getItem('fvuid')
    await this.newRequest('patch', `${IDENTITIES_URL}/${fvuid}`, payload)
  },
  logScreen: async function(name, data) {
    const sid = window.localStorage.getItem('fvsid')
    if (sid) {
      const payload = {
        type: 'screen',
        name: name,
        data: data
      }
      return await this.newRequest(
        'post',
        `${SESSIONS_URL}/${sid}/events`,
        payload
      )
    }
  },
  logEvent: async function(name, data) {
    const sid = window.localStorage.getItem('fvsid')
    if (sid) {
      const payload = {
        type: 'action',
        name: name,
        data: data
      }
      return await this.newRequest(
        'post',
        `${SESSIONS_URL}/${sid}/events`,
        payload
      )
    }
  }
}
